import React, { useState, useEffect } from "react";
import { IntlProvider } from "react-intl";
import { useIntl } from "react-intl";

const TranslationsProvider = ({ children, fetchTranslations }) => {
  // Get locale and messages from main app provider
  const { locale, messages: parentMessages } = useIntl();
  const [translations, setTranslations] = useState({
    locale: locale || "en",
    messages: {},
  });

  // Effect hook for fetching translations when the language changes
  useEffect(() => {
    fetchTranslations(locale).then((data) => {
      setTranslations(data);
    });
  }, [locale]); // This useEffect will run whenever locale changes

    // Merge parent messages with local translations, local takes precedence
    const mergedMessages = {
      ...(parentMessages.default || parentMessages),
      ...(translations.messages.default || translations.messages),
    };
    return (
      <IntlProvider locale={translations.locale} messages={mergedMessages}>
        {children}
      </IntlProvider>
    );
};

export default TranslationsProvider;